import { Component, Input } from "@angular/core";

@Component({
    selector: "app-service-fee-associated-mids-table-cell-content",
    templateUrl: "./service-fee-associated-mids-table-cell-content.component.html",
    styleUrls: ["./service-fee-associated-mids-table-cell-content.component.less"],
    standalone: false
})
export class ServiceFeeAssociatedMidsTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

}
